// PaymentMethodModal stub - Payment integrations discontinued
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface PaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  companyId: string;
  paymentMethods?: any[];
}

export function PaymentMethodModal({ isOpen, onClose }: PaymentMethodModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Método de Pagamento</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground">
          A funcionalidade de métodos de pagamento foi descontinuada.
        </p>
      </DialogContent>
    </Dialog>
  );
}

export default PaymentMethodModal;
